import React, { useEffect, useState } from "react";
import { View, ScrollView, StyleSheet, Dimensions} from "react-native";
import { Table, Row } from 'react-native-table-component';


const InvoiceHistoryTable = ({ tableHead, widthArr, combineInvoiceNumber, dataArr}) =>{
    
    const {width, height} = Dimensions.get('window');

    const [isSmallScreen, setIsSmallScreen ] = useState(false);

    useEffect(()=>{
        if(width<640){
            setIsSmallScreen(true);
        }
    },[width])
    return (
        <View>
            
                    <View style={[styles.tableContainer]}>
                        <Table borderStyle={{borderWidth: 1, borderColor: '#EF9A19'}}>
                            <Row data={tableHead} widthArr={isSmallScreen?['25%','48%','27%']:widthArr} style={styles.row} textStyle={styles.headText}/>
                        </Table>
                        <ScrollView style={styles.dataWrapper}>
                            <Table borderStyle={{borderWidth: 1, borderColor: '#EF9A19'}}>
                                {
                                combineInvoiceNumber.map((bill, index) => (
                                    <Row
                                        key={index}
                                        data={dataArr(bill)}
                                        widthArr={isSmallScreen?['25%','48%','27%']:widthArr}
                                        textStyle={styles.rowText}
                                    />
                                ))
                                }
                            </Table>
                        </ScrollView>
                    </View>
            
        </View>
    )
}

const styles = StyleSheet.create({

    tableContainer:{
        padding: 20,
    },

    row:{
        backgroundColor: '#1e5d8a',
    },
    headText:{
        textAlign: 'center',
        padding: 10,
        color: '#cfd1d0',
        fontWeight: '400',
        
    },
    dataWrapper: { 
        marginTop: -1 
    },
    rowText:{
        padding: 10,
        textAlign: 'center',
        color:'#070708',
        fontWeight: '300',
    },
})


export default InvoiceHistoryTable;